import { render, staticRenderFns } from "./HumanCapitalNursingCareLeaveReport.vue?vue&type=template&id=717e30e0&scoped=true&"
import script from "./HumanCapitalNursingCareLeaveReport.vue?vue&type=script&lang=js&"
export * from "./HumanCapitalNursingCareLeaveReport.vue?vue&type=script&lang=js&"
import style0 from "./HumanCapitalNursingCareLeaveReport.vue?vue&type=style&index=0&id=717e30e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "717e30e0",
  null
  
)

export default component.exports